import { FC, useState } from 'react'

import WisePayout from 'src/Components/WisePayout'
import { ChangeEmailForm } from 'src/Components/ChangeEmailForm'

import ChangePassword from '../ChangePassword'
import { TabKeys } from '../../halpers'

import { DeleteAccountTab } from './DeleteAccountTab'

interface SettingsTabsProps {
  active: string
}

export const SettingsTabs: FC<SettingsTabsProps> = ({ active }) => {
  const [modal, setModal] = useState(false)

  const modalToggle = (): void => {
    setModal(!modal)
  }

  if (active === TabKeys.payout) {
    return <WisePayout />
  }
  if (active === TabKeys.password) {
    return <ChangePassword />
  }
  if (active === TabKeys.email) {
    return <ChangeEmailForm />
  }
  if (active === TabKeys.delete) {
    return <DeleteAccountTab modal={modal} modalToggle={modalToggle} />
  }
  return null
}
